import styled, { css } from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global';

const buttonStyle = css`
  align-items: center;
  background-color: inherit;
  border: none;
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;

  svg {
    transform: scale(0.85);
  }
`;
export const Container = styled.div`
  align-items: center;
  border: 1px ${colours.GREY} solid;
  display: flex;
  height: 100%;
  margin-bottom: ${spacing.XXXS};
  min-height: 44px;
  position: relative;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    height: 50px;
  }
`;
export const Label = styled.span`
  ${TypographyStyles.Body.Medium.Regular}
  color: ${colours.GREY};
  padding-left: ${spacing.L};
  padding-right: ${spacing.XXXL};
`;
export const Value = styled.span`
  ${TypographyStyles.Body.Medium.Regular}
  order: 2;
  pointer-events: none;
`;
export const DecreaseButton = styled.button`
  ${buttonStyle}
  justify-content: flex-start;
  order: 1;
  padding-left: ${spacing.XXXS};
  &:disabled {
    cursor: not-allowed;
    & svg path {
      fill: ${colours.MID_GREY};
    }
  }
`;
export const IncreaseButton = styled.button`
  ${buttonStyle}
  justify-content: flex-end;
  order: 3;
  padding-right: ${spacing.XXXS};
  &:disabled {
    cursor: not-allowed;
    & svg path {
      fill: ${colours.MID_GREY};
    }
  }
`;
export const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  left: ${spacing.XXS};
  position: absolute;
  top: 0;
`;
export const ControlsWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  position: absolute;
  right: 3px;
  top: 0;
  width: 78px;

  @media ${media.greaterThan('lg')} {
    right: 6px;
  }
`;
